import { useField } from "formik";

interface IProps {
  name: string;
  label: string;
  classNames?: string[];
  containerClassName?: string[];
  classTextError?: string[];
  placeholder?: string;
  maxLength?: number;
}

const FormTextArea = ({ // FormTextArea
  name,
  label,
  classNames = [],
  containerClassName = [],
  classTextError = [],
  placeholder = "",
  maxLength,
  ...props
}: IProps) => {
  const [field, { touched, error }] = useField(name);

  return (
    <div
      className={["container-input", ...containerClassName].join(" ").trim()}
    >
      <label className="input-text">{label}</label>
      <textarea
        className={["input-auth", ...classNames].join(" ").trim()}
        placeholder={placeholder}
        maxLength={maxLength}
        {...field}
        {...props}
      />
      {error && touched ? (
        <div className="box-text-error">
          <p className={["text-error", ...classTextError].join(" ").trim()}>
            {error}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default FormTextArea;
